import { render, staticRenderFns } from "./student_situation_list.vue?vue&type=template&id=cb0c3d20&scoped=true"
import script from "./student_situation_list.vue?vue&type=script&lang=js"
export * from "./student_situation_list.vue?vue&type=script&lang=js"
import style0 from "../assets/styles/student-situation.scss?vue&type=style&index=0&id=cb0c3d20&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_16d71e7cf8bf5c3e53d15d26d70867ca/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb0c3d20",
  null
  
)

export default component.exports